module.exports = __webpack_public_path__ + "static/media/chat.ab83758e.svg";